import React, {useContext} from 'react';
import {AsyncFileUploaderContext} from '../../../../AsyncFileUploader/AsyncFileUploaderContext';
import {humanFileSize} from '../../../../../helpers/humanFileSize';

export default function NowUploadedItemDetails({hash}: { hash: string }) {
    const {getItem} = useContext(AsyncFileUploaderContext);

    const item = getItem(hash);
    const meta = item?.getMeta();
    const file = item?.getFile();
    if (!item || !meta || !file) {
        return null;
    }

    return <div className="header__async-uploader-indicator__item">
        <div className="header__async-uploader-indicator__item__progress">
            {humanFileSize(meta.sentBytes)} / {humanFileSize(meta.totalBytes)}
        </div>
        <div className="header__async-uploader-indicator__item__name">
            {file.name}
        </div>
    </div>;
}
